import React from 'react';

import { Switch } from '@gogame/components';

import { useFiltersFieldsManagerContext } from './FilterFieldsManager';

export const CompareFilters = () => {
  const { compared, onToggleFields } = useFiltersFieldsManagerContext();

  return (
    <Switch
      label={'Comparing mode'}
      checked={compared}
      onChange={onToggleFields}
    />
  );
};

export default CompareFilters;
